import { render } from "./IconVodChannel.vue?vue&type=template&id=29ff6bb2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconVodChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29ff6bb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29ff6bb2', __exports__)) {
    api.reload('29ff6bb2', __exports__)
  }
  
  module.hot.accept("./IconVodChannel.vue?vue&type=template&id=29ff6bb2", () => {
    api.rerender('29ff6bb2', render)
  })

}


export default __exports__